// removed by extract-text-webpack-plugin
module.exports = {"root":"_10p9ko0"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/SearchResultPage/components/SearchResultSummary/components/Filters/Filters.less
 ** module id = 792
 ** module chunks = 0
 **/